/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_Qk_81_107 as Componente_Qk_81_107,
  rec_Componente_Zk_90_107 as Componente_Zk_90_107,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_FormularioRol as FormularioRol,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_Lk as Lk,
  rec_Pk as Pk,
  rec_React as React,
  rec_Rk as Rk,
  rec_Ti as Ti,
  rec_api as api,
  rec_wi as wi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function Roles({ recurso: e }) {
  let { confirmar: t } = Fo(),
    n = Lk[e],
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)(!0),
    [s, c] = (0, React.useState)(``),
    [l, u] = (0, React.useState)(null),
    f = (0, React.useCallback)(async () => {
      o(!0);
      try {
        (i(await api(`/${e}`)), c(``));
      } catch (e) {
        c(e.message);
      } finally {
        o(!1);
      }
    }, [e]);
  (0, React.useEffect)(() => {
    f();
  }, [f]);
  async function p(n) {
    if (
      await t({
        titulo: `Eliminar "${n.nombre}"`,
        confirmarTexto: `Eliminar`,
        peligro: !0,
      })
    )
      try {
        (await api(`/${e}/${n.id}`, {
          method: `DELETE`,
        }),
          f());
      } catch (e) {
        c(e.message);
      }
  }
  return (
    <div
      className={`flex flex-col gap-3`}
      children={[
        <EstadoError mensaje={s} onReintentar={f} />,
        <div
          className={`flex justify-end`}
          children={
            <button
              type={`button`}
              onClick={() => u({})}
              className={zo}
              children={[
                <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                ` `,
                Rk[e],
              ]}
            />
          }
        />,
        a ? (
          <Componente_Zk_90_107 />
        ) : r.length === 0 ? (
          <Componente_Qk_81_107
            texto={`Todavía no hay ${(Pk.find((t) => t.id === e)?.label ?? e).toLowerCase()}.`}
          />
        ) : (
          <ul
            className={`flex flex-col gap-2`}
            children={r.map((e) => (
              <li
                key={e.id}
                className={`${Bo} flex items-center gap-3`}
                children={[
                  <span
                    className={`flex-1 text-sm text-(--text-h)`}
                    children={e.nombre}
                  />,
                  e.esAdminSistema ? (
                    <span
                      className={`rounded-full border border-(--accent-border) px-2 py-0.5 text-[10px] text-(--accent-texto)`}
                      children={`Ve todo`}
                    />
                  ) : e.esAdminPlanner ? (
                    <span
                      className={`rounded-full border border-(--border) px-2 py-0.5 text-[10px] text-(--text)`}
                      children={`Configura`}
                    />
                  ) : null,
                  !e.activo && (
                    <span
                      className={`rounded-full bg-(--panel) px-2 py-0.5 text-[10px] uppercase text-(--text)`}
                      children={`inactivo`}
                    />
                  ),
                  <button
                    type={`button`}
                    onClick={() =>
                      u({
                        editar: e,
                      })
                    }
                    aria-label={`Editar`}
                    className={`rounded-lg p-1 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                    children={(0, JSXRuntime.jsx)(wi, {
                      className: `h-3.5 w-3.5`,
                    })}
                  />,
                  <button
                    type={`button`}
                    onClick={() => p(e)}
                    aria-label={`Eliminar`}
                    className={`rounded-lg p-1 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                    children={<Ki className={`h-3.5 w-3.5`} />}
                  />,
                ]}
              />
            ))}
          />
        ),
        l && (
          <FormularioRol
            recurso={e}
            singular={n}
            nuevoLabel={Rk[e]}
            editar={l.editar}
            onClose={() => u(null)}
            onGuardado={() => {
              (u(null), f());
            }}
          />
        ),
      ]}
    />
  );
}
